__turbopack_context__.v({
  "root": "DividerHorizontal-module__33JC_G__root",
});
